<template>
  <div class="single-ticket-cargo-container">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'SingleTicketCargoIndex'
}
</script>

<style lang="less" scoped>
.single-ticket-cargo-container {
  padding: 20px;
  height: 100%;
}
</style>